<template>
    <div class="analysis_side">
        <v-tabs show-arrows v-model="activeKey">
                <v-tab key="0">分析</v-tab>
                <v-tab key="1">过滤</v-tab>
                <v-tab-item key="0">
                    <analySide></analySide>
                </v-tab-item>
                <v-tab-item key="1">
                    <analyFilter @filterChange="filterChange" @secondFilter="secondFilter"></analyFilter>
                </v-tab-item>
        </v-tabs>
    </div>
</template>
<script>
import analyFilter from '@/components/analyse/analyFilter.vue';
import analySide from "@/components/analyse/analySide.vue";
export default {
    data() {
        return {
            activeKey: 0
        }
    },
    components: {
        analyFilter,
        analySide
    },
    methods: {
        filterChange(val) {
            if(val) {
                this.$emit('setAnalyFilterKey', true)
            }
            // console.log('val', val)
        },
        secondFilter(val) {
            this.$emit('setAnalySecKey', val)
        }
    }
}
</script>